import script from "./TopNavMenuDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNavMenuDropdown.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"TopNavMenuDropdown.vue"]])

export default __exports__